import React, { useState, useEffect } from "react"
import { useTranslation } from "../../i18n/TranslationProvider"

import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers"

import { Row, Col, Form } from "react-bootstrap"
import Sallie from "../Sallie"
import LabelledInput from "../LabelledInput"
import DisabledButton from "../StyledComponents/DisabledButton"

import { ResetPw1Schema } from "./validation"
import { sendResetPwEmail } from "../../api/helpReq"

const ResetPassword1 = () => {
  const { t, language } = useTranslation();

  const [isLoading, setIsLoading] = useState(false)
  const [sallieMsg, setSallieMsg] = useState(t("signIn.sallieResetPassword.resetPassword"))
  const { register, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(ResetPw1Schema)
  })
  const { touched } = formState

  useEffect(() => {
    setSallieMsg(t("signIn.sallieResetPassword.resetPassword"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      data.email = data.email.toLowerCase();
      await sendResetPwEmail(data);
      setSallieMsg(
        `${t("signIn.sallieResetPassword.emailSent")} ${data.email}.`
      );
    } catch (error) {
      console.error("Error sending password reset email:", error);

      if (error.response && error.response.status === 404) {
        // Handle 404 Not Found error
        setSallieMsg(t("signIn.sallieResetPassword.noAccount"));
      } else {
        // Handle other errors (e.g., 500 Internal Server Error)
        setSallieMsg(t("signIn.sallieResetPassword.error"));
      }
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <Sallie text={sallieMsg} />
      <Row className="d-flex justify-content-center">
        <Col xs={10} md={6}>
          <Form
            autoComplete="on"
            method="POST"
            className="mt-2"
            style={{ margin: "0 auto" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <LabelledInput
              labelAs="h6"
              name="email"
              type="email"
              label={t("signIn.signin.email")}
              autoComplete="email"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <DisabledButton
              disabled={isLoading}
              className="w-100"
              type="submit"
              variant="outline-primary"
            >
              {t("signIn.continue")}
            </DisabledButton>
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default ResetPassword1